import * as React from "react";

import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader } from "Components/ui";
import { cn } from "utils/cn";

type DialogSize = "sm" | "md" | "lg" | "xl";

// Billing's forms were laid out for these widths, a step wider than the kit's sizes.
const SIZE_CLASSES: Record<DialogSize, string> = {
  sm: "max-w-md",
  md: "max-w-xl",
  lg: "max-w-3xl",
  xl: "max-w-5xl",
};

interface DialogShellProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  onClose: () => void;
  size?: DialogSize;
  footer?: React.ReactNode;
  /** Close when the backdrop is clicked (off for dialogs that show secrets once). */
  closeOnBackdrop?: boolean;
  children?: React.ReactNode;
}

/** Billing dialogs on the kit's Dialog; mount it only while open. */
const DialogShell: React.FC<DialogShellProps> = ({
  title,
  subtitle,
  onClose,
  size = "md",
  footer,
  closeOnBackdrop = true,
  children,
}) => (
  <Dialog
    open
    onOpenChange={(open) => {
      if (!open) onClose();
    }}
  >
    <DialogContent
      className={cn(SIZE_CLASSES[size])}
      onInteractOutside={closeOnBackdrop ? undefined : (event) => event.preventDefault()}
    >
      <DialogHeader title={title} description={subtitle} />
      <DialogBody>{children}</DialogBody>
      {footer && <DialogFooter>{footer}</DialogFooter>}
    </DialogContent>
  </Dialog>
);

export default DialogShell;
